import {initializeApp} from 'firebase/app'
import {connectAuthEmulator, getAuth, GoogleAuthProvider} from 'firebase/auth'
import {connectFirestoreEmulator, getFirestore} from 'firebase/firestore'
import {connectFunctionsEmulator, getFunctions, httpsCallable} from 'firebase/functions'
import {isDev} from '../utils/consts'

const app = initializeApp({
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_AUTHDOMAIN,
  projectId: process.env.NEXT_PUBLIC_PROJECTID,
  storageBucket: process.env.NEXT_PUBLIC_STORAGEBUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_MESSAGINGSENDERID,
  appId: process.env.NEXT_PUBLIC_APPID,
})

const auth = getAuth()
auth.useDeviceLanguage()
const db = getFirestore()
const functions = getFunctions()

const googleProvider = new GoogleAuthProvider()

if (isDev) {
  // connectAuthEmulator(auth, 'http://localhost:9099')
  // connectFirestoreEmulator(db, 'localhost', 8080)
  connectFunctionsEmulator(functions, 'localhost', 5001)
}

export {auth, db, googleProvider, functions, httpsCallable, app}
